import React from 'react';

export const Loader = props => (
  <>
    <div className="loader__holder">
      <div className="loader__container">
        <div className="loader__content">
          <div />
          <div />
        </div>
      </div>
    </div>
  </>
);
